import EcoNavProduct, { EcoNavProductItemProps, EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import { LangText } from './LangText';
import gtm from '@/utils/gtm';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

export default function ProductNav({ activeTab, tabCallback, buyLink }: { activeTab: string; tabCallback?: any; buyLink: string }) {
    const { locale = 'us', pathname, asPath, query } = useRouter();
    const TextA = LangText[locale as 'us'] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);
    const _query = String(asPath.split('?')[1])?.split('#')[0];
    const { pageStatus } = useProductStore();
    const { t } = useLang('powerBank');
    const IS_US = ['us', 'ca'].includes(locale);
    const { getSystemTime } = useGlobal();
    const endTime = new Date('2025/09/08 15:00:00 GMT+8').getTime();

    const dataA: EcoNavProductProps = {
        theme: 'black',
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : `${thePageUrl}${_query !== 'undefined' ? `?${_query}` : ''}`,
            },
            {
                value: 'Support',
                label: TextA.tab_support,
                href: `${thePageUrl}/support${_query !== 'undefined' ? `?${_query}` : ''}`,
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                href: `${thePageUrl}${_query !== 'undefined' ? `?${_query}` : ''}#CompareSelector`,
                disableTabHighlight: true,
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'click_anchor',
                    position: t('M.title'),
                    button_name: TextA.tab_specs,
                },
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: ['jp', 'ph'].includes(locale) || IS_US ? TextA.btn_buy : pageStatus === IPageStatus.statusA ? TextA.prepare_btn : TextA.btn_buy,
                href:
                    ['jp', 'ph'].includes(locale) || IS_US
                        ? `${thePageUrl}${_query !== 'undefined' ? `?${_query}` : ''}#rapid-C`
                        : `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID`,
            },
        ].filter(Boolean) as EcoNavProductItemProps[],
    };

    let systemTime = getSystemTime();
    const { _timer } = query as any;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    if (IS_US && systemTime <= endTime) {
        dataA.tabItems?.splice(1, 0, {
            value: 'Beneft',
            label: TextA.btn_beneft,
            href: `${thePageUrl}${_query !== 'undefined' ? `?${_query}` : ''}#EarlyBird_US`,
            disableTabHighlight: true,
        });
    }
    const tabChange = (item: EcoNavProductItemProps) => {
        if (tabCallback) {
            tabCallback(item.value);
        }
    };
    const buyChange = (item: EcoNavProductItemProps) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position:
                locale === 'jp' || IS_US
                    ? t('C.title')
                    : `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID`,
            button_name: item.label,
        });
    };
    return (
        <div className={`${styles.comp} GtmModuleData-section`} data-section-id={'ProductNav'}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'name1',
                        label: TextA.product_name,
                        href: undefined,
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={activeTab}
                onTabChange={tabChange}
                backgroundColor="#000"
                onBuyChange={buyChange}
                productNameActiveColor="#fff"
            />
        </div>
    );
}
